import React, { useState } from 'react';
import {
    withSendBird,
    Channel as SBConversation,
    ChannelList as SBChannelList,
    ChannelSettings as SBChannelSettings,
} from 'sendbird-uikit';
import Sdk from 'sendbird';
import '../../../assets/scss/newChat.scss';

const ChatApp = (props) => {
    const { userList } = props;
    const sendBirdInstance = Sdk.getInstance();

    const [currentChannelUrl, setCurrentChannelUrl] = useState('');
    const [showSettings, setShowSettings] = useState(false);

    return (
        <div className='customized-app'>
            <div className='sendbird-app__wrap'>
                <div className='sendbird-app__channellist-wrap'>
                    <SBChannelList
                        onBeforeCreateChannel={(selectedUsers) => {
                            const params = new sendBirdInstance.GroupChannelParams();
                            params.addUserIds(selectedUsers);
                            params.isDistinct = true
                            return params;
                        }}
                        onChannelSelect={(channel) => {
                            if (channel && channel.url) setCurrentChannelUrl(channel.url);
                            else setCurrentChannelUrl(null);
                        }}
                        queries={{
                            applicationUserListQuery: {
                                userIdsFilter: userList,
                            },
                        }}
                    />
                </div>
                <div className='sendbird-app__conversation-wrap'>
                    <SBConversation
                        channelUrl={currentChannelUrl}
                        useMessageGrouping={true}
                        onChatHeaderActionClick={() => {
                            setShowSettings(true);
                        }}
                    />
                </div>
                {showSettings && (
                    <div className='sendbird-app__settingspanel-wrap'>
                        <SBChannelSettings
                            channelUrl={currentChannelUrl}
                            onCloseClick={() => {
                                setShowSettings(false);
                            }}
                        />
                    </div>)}
            </div>
        </div>
    );
};

export default withSendBird(ChatApp);
